<template>
    <div class="form-group">
        <label :for="id">{{ label }}</label>
        <input
            :type="type" 
            :id="id" 
            :value="value"
            :class="{ 'is-invalid': !valid }"
            class="form-control validation-input"
            @input="onChange"
            @change="onChange"
            @blur="onBlur"
            @keypress.enter.prevent="validate"
            @reset-input="reset"
            @validate-input="validate"
            v-bind="$attrs"
            ref="input"
        >
        <small class="form-text text-muted">{{ helperText }}</small>
        <div class="invalid-feedback">{{ invalidMessage }}</div>
    </div>
</template>

<script>
export default {
    props: {
        id: String,
        type: String,
        label: String,
        value: [String, Number],
        helperText: String,
        validator: Function,
    },
    emits: ['input'],
    data() {
        return {
            valid: true,
            invalidMessage: ''
        }
    },
    methods: {
        validate(e) {
            if(this.validator && typeof this.validator === "function") {
                const result = this.validator(e.target.value)

                if(typeof result === "object") {
                    this.valid = result.valid;
                    this.invalidMessage = result.invalidMessage;
                } else {
                    this.valid = result;
                    this.invalidMessage = result === true ? "" : "This field is invalid"
                }

                if(!this.valid) e.target.setAttribute('is-invalid', 'true');
                else e.target.removeAttribute('is-invalid')
            }
        },
        reset(e) {
            this.valid = true;
            this.invalidMessage = "";
            e.target.removeAttribute('is-invalid');
        },
        onChange(e) {
            this.$emit('input', e.target.value.trim());
            this.validate(e);
        },
        onBlur(e) {
            this.validate(e);
        }
    }
}
</script>